import apiClient from "@apis/index";
import Routes from "@apis/routes";
import { SearchResultResponse } from "@src/types/diamondSearchResult";
import { useInfiniteQuery, useMutation } from "@tanstack/react-query";
import {
  getCollectionAPI,
  getCollectionPayload,
} from "@apis/utils/search-results";
import { ProductCategory } from "@utils/constants";
import { SearchResultsAndFavoritesEnum } from "@utils/product/searchResultConstants";
import { useSearchApiDomain } from "@redux/slices/globalSlice";
import { Platform } from "react-native";

export const useSearchResultDiamond = () => {
  const searchApiDomain = useSearchApiDomain();
  return useMutation({
    mutationFn: (data: { vdb: any }) =>
      apiClient.post<SearchResultResponse>(Routes.SEARCH_RESULT_DIAMOND, data, {
        ...(searchApiDomain && { baseURL: searchApiDomain }),
      }),
  });
};

export const useSearchResultGemstone = () => {
  const searchApiDomain = useSearchApiDomain();
  return useMutation({
    mutationFn: (data: { gemstone: any }) =>
      apiClient.post<SearchResultResponse>(
        Routes.SEARCH_RESULT_GEMSTONE,
        data,
        { ...(searchApiDomain && { baseURL: searchApiDomain }) }
      ),
  });
};

export const useSearchResultJewelry = () => {
  const searchApiDomain = useSearchApiDomain();
  return useMutation({
    mutationFn: (data: { jewelry: any }) =>
      apiClient.post<SearchResultResponse>(Routes.SEARCH_RESULT_JEWELRY, data, {
        ...(searchApiDomain && { baseURL: searchApiDomain }),
      }),
  });
};

export const useSaveSavedSearch = () => {
  return useMutation({
    mutationFn: (data: any) =>
      apiClient.post<SearchResultResponse>(Routes.SAVED_SEARCH_RESULT, data),
  });
};

export const useSearchResults = (
  type: ProductCategory,
  data: any,
  selectedViewType?: SearchResultsAndFavoritesEnum,
  userId?: number,
  saved_searches?: any,
  currency?: any,
  locale?: string
) => {
  const searchApiDomain = useSearchApiDomain();
  return useInfiniteQuery(
    [
      "SEARCH_RESULTS",
      type,
      JSON.stringify(data),
      selectedViewType,
      userId,
      saved_searches,
      currency,
      locale,
    ],
    ({ pageParam = 1 }) => {
      return apiClient.post<SearchResultResponse>(
        getCollectionAPI(type),
        getCollectionPayload(type, {
          ...data,
          page_number: pageParam,
        }),
        { ...(searchApiDomain && { baseURL: searchApiDomain }) }
      );
    },
    {
      cacheTime: 0,
      staleTime: 0,
      // @ts-ignore — maxPages is supported at runtime (v4.29+) but types are outdated
      maxPages: Platform.OS === "ios" || Platform.OS === "android" ? 3 : 5,
      getNextPageParam: (lastPage, allPages) => {
        const payload = lastPage?.data?.response?.body;
        const hasNextPage = (
          payload?.diamonds ||
          payload?.gemstones ||
          payload?.jewelries ||
          []
        ).length;
        return hasNextPage ? allPages.length + 1 : undefined;
      },
    }
  );
};
